import { useCallback, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Logomarca } from '../../assets';
import { ReactComponent as Menu } from '../../assets/icons/menu.svg';
import { useAuth } from '../../hooks/useAuth';
import * as S from './styles';

const Header = () => {
  const { signOut, user } = useAuth();
  const [isShowMenuMobile, setIsShowMenuMobile] = useState(false);

  const loadMenus = useCallback(() => {
    return (
      <S.Navigation>
        <NavLink
          to={`${process.env.PUBLIC_URL}/register-os`}
          activeClassName="active"
        >
          Cadastrar OS
        </NavLink>
        <NavLink
          to={`${process.env.PUBLIC_URL}/search-os`}
          activeClassName="active"
        >
          Buscar OS
        </NavLink>
        <NavLink
          to={`${process.env.PUBLIC_URL}/catalog`}
          activeClassName="active"
        >
          Catálogo
        </NavLink>
        <NavLink
          to={`${process.env.PUBLIC_URL}/manual`}
          activeClassName="active"
        >
          Manual de Medidas
        </NavLink>
        <NavLink
          to={`${process.env.PUBLIC_URL}/assistance`}
          activeClassName="active"
        >
          Assistência
        </NavLink>
        <S.Separator />
        <button type="button" onClick={signOut}>
          Sair
        </button>
      </S.Navigation>
    );
  }, [signOut]);

  const handleCloseMenuMobile = (): void => {
    setIsShowMenuMobile(false);
  };

  const handleOpenMenuMobile = (): void => {
    setIsShowMenuMobile(true);
  };

  return (
    <S.Container>
      <S.LogoContainer>
        <img
          src={Logomarca}
          alt="Logomarca com a letra C no centro e bolinhas sobrevoando"
        />
        <span>{user.login}</span>
      </S.LogoContainer>

      {loadMenus()}

      <S.MenuMobileButton onClick={handleOpenMenuMobile}>
        <div>
          <Menu />
          <span>Menu</span>
        </div>
        <span>{user.login}</span>
      </S.MenuMobileButton>

      <S.MenuMobile isOpen={isShowMenuMobile}>
        <header>
          <span>Menu</span>
          <button type="button" onClick={handleCloseMenuMobile}>
            &times;
          </button>
        </header>
        {loadMenus()}
      </S.MenuMobile>
      {isShowMenuMobile && <S.Overlay />}
    </S.Container>
  );
};

export default Header;
